<template>
    <button
        class="rounded-full border-2 border-purple-700 bg-purple-700 px-6 py-2 text-white transition-colors duration-300 hover:bg-transparent disabled:cursor-not-allowed disabled:opacity-50"
        data-spec-class="configurator-confirm"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'FeConfiguratorConfirm',
};
</script>
